import { GameMode, Language, WordLength } from '../types/game'

// Animation timings
export const ANIMATION = {
  FLIP: 500,
  DANCE: 500,
  POPUP: 200,
} as const

// Language configurations
export const LANGUAGES: Record<string, Language> = {
  shona: {
    name: 'Shona',
    isoStandard: 'ISO 639-1',
    code: 'sn',
    direction: 'ltr',
    excludedCharacters: ['L', 'Q', 'X', 'Ñ', 'Ŋ'],
    specialCharacters: ["'"],
  },
  english: {
    name: 'English',
    isoStandard: 'ISO 639-1',
    code: 'en',
    direction: 'ltr',
    excludedCharacters: [],
  },
}

// Game modes configuration
export const GAME_MODES: Record<WordLength, GameMode> = {
  3: {
    wordLength: 3,
    maxGuesses: 4,
    label: '3 Letters',
    description: 'Play with three-letter Shona words - Quick and simple',
    examples: ['I', 'T', 'A'],
    language: LANGUAGES.shona,
  },
  4: {
    wordLength: 4,
    maxGuesses: 5,
    label: '4 Letters',
    description: 'Play with four-letter Shona words - Beginner friendly',
    examples: ['B', 'E', 'T', 'E'],
    language: LANGUAGES.shona,
  },
  5: {
    wordLength: 5,
    maxGuesses: 6,
    label: '5 Letters',
    description: 'Classic mode with five-letter Shona words',
    examples: ['K', 'W', 'E', 'T', 'E'],
    language: LANGUAGES.shona,
  },
  6: {
    wordLength: 6,
    maxGuesses: 7,
    label: '6 Letters',
    description: 'Challenge mode with six-letter Shona words',
    examples: ['R', 'U', 'R', 'I', 'M', 'I'],
    language: LANGUAGES.shona,
  },
} as const

// Default game settings
export const DEFAULT_MODE: WordLength = 5
export const DEFAULT_SETTINGS = {
  darkMode: false,
  highContrast: false,
} as const

// Alert durations
export const ALERT_TIME = {
  SUCCESS: 5000,
  ERROR: 1000,
  PERMANENT: undefined,
} as const
